import type { DatadogLogEntry } from "./types";

import { fetchWithClientOrigin } from "../api/client-origin";
import { datadogEnv } from "./datadog-env";

async function submitLogs(logs: DatadogLogEntry[]): Promise<void> {
  const { apiKey, logIntakeUrl, service, source } = datadogEnv();

  if (!apiKey) {
    console.warn("submitLogs called without DATADOG_API_KEY.");
    return;
  }

  if (!Array.isArray(logs) || logs.length === 0) {
    console.warn("submitLogs called with empty or invalid logs array.");
    return;
  }

  // https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#reserved-attributes
  const logsToSend = logs.map((log) => ({
    ddsource: source,
    service,
    ...log,
  }));

  try {
    const response = await fetchWithClientOrigin(logIntakeUrl, {
      body: JSON.stringify(logsToSend),
      headers: {
        "Content-Type": "application/json",
        "DD-API-KEY": apiKey,
      },
      method: "POST",
    });

    if (!response.ok) {
      const errorBody = await response.text();
      console.error(
        `Datadog API submission failed (Status: ${response.status}):`,
        errorBody,
      );
      throw new Error(
        `Datadog API submission failed (Status: ${response.status})`,
      );
    }
  } catch (error: unknown) {
    if (
      error instanceof Error &&
      error.message.startsWith("Datadog API submission failed")
    ) {
      throw error;
    }

    const message = error instanceof Error ? error.message : String(error);
    console.error("Failed to submit logs to Datadog:", message);
    throw error instanceof Error ? error : new Error(message);
  }
}

export { submitLogs };
